import { render, staticRenderFns } from "./ModalNewFeature.vue?vue&type=template&id=0f9bffea&scoped=true&"
import script from "./ModalNewFeature.vue?vue&type=script&lang=js&"
export * from "./ModalNewFeature.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewFeature.vue?vue&type=style&index=0&id=0f9bffea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9bffea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
